import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import EditProspectPageContent from "app/components/prospect/EditProspectPageContent";

const EditProspectPage = (props) => {
  const { t } = useTranslation();

  return (
    <Page
      hasDrawer={false}
      pageTitle={t("LookupProspect.prospectDetails")}
      hasBackButton={true}
      backButtonTooltip={t("common.backButtonToolTip")}
      contentComponent={EditProspectPageContent}
      {...props}
    />
  );
};

export default EditProspectPage;
